<template>
    <div :class="{'items-centered': centered}">
        <div
            class="preloader"
            v-bind="preloaderAttrs"
        ></div>
    </div>
</template>

<script>
export default {
    props: {
        centered: {
            type: Boolean,
            default: true,
        },
        preloaderAttrs: {
            type: Object,
            default: () => ({}), // Empty object as default
        },
    },
}
</script>

<style scoped lang="scss">
.items-centered {
    align-items: center;
    display: flex;
    justify-content: center;
}
</style>
